import { render } from "./MaintenanceScheduleForm.vue?vue&type=template&id=2000a633&scoped=true&ts=true"
import script from "./MaintenanceScheduleForm.vue?vue&type=script&lang=ts"
export * from "./MaintenanceScheduleForm.vue?vue&type=script&lang=ts"

import "./MaintenanceScheduleForm.vue?vue&type=style&index=0&id=2000a633&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2000a633"]])

export default __exports__